import { datadogRum } from "@datadog/browser-rum";

/**
 * Tag a Club-in-Club URL with our RUM session. The portal reports to its own RUM app, so
 * the trip is a second session there; it records ours so that session links back to this
 * one. There is none to add when RUM is off, as it is locally.
 */
export function addWebbySession(destination: URL): void {
    const session = datadogRum.getInternalContext()?.session_id;
    if (session) destination.searchParams.set("webby_session", session);
}
